import * as s from "./website-content.scss";
import {
    Component
} from "../../../../../sedestral/framework/interface/component/Component";
import {WebsiteBlackPresentationComponent} from "../black/presentation/WebsiteBlackPresentationComponent";
import {NetworkVendor} from "../../../../../network/NetworkVendor";
import {Resources} from "../../../../../resources/Resources";
import {WebsiteBlackStepsComponent} from "../black/steps/WebsiteBlackStepsComponent";
import {WebsiteBlackTextComponent} from "../black/text/WebsiteBlackTextComponent";
import {WebsiteBlackFlowGridComponent} from "../black/flow/grid/WebsiteBlackFlowComponent";
import {WebsiteBlackFlowComponent} from "../black/flow/WebsiteBlackFlowComponent";
import {
    ComponentWebsiteBlackAllieSimple
} from "../black/allie/simple/WebsiteBlackAllieSimpleComponent";
import {WebsiteBlackFlowStepsComponent} from "../black/flow/steps/WebsiteBlackFlowStepsComponent";

export class WebsiteContentAuditComponent extends Component {
    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteContent}">
                <div class="${s.content}">
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackPresentationComponent({
                            startText: Resources.t("words.auditStartFree"),
                            title: Resources.t("words.auditBoostTrafficPotential"),
                            description: Resources.t("words.auditSeoOptimizationDescription"),
                            people: false,
                            center: true,
                            background: "fire"
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackStepsComponent({
                            title: Resources.t("words.features"),
                            icon: "seo",
                            contents: [
                                {
                                    name: Resources.t("words.auditAudit"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-ai.mp4"),
                                    duration: 17500
                                },
                                {
                                    name: Resources.t("words.auditBestOpportunities"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-aj.mp4"),
                                    duration: 14000
                                },
                                {
                                    name: Resources.t("words.auditOptimization"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-ak.mp4"),
                                    duration: 20000
                                },
                            ]
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackTextComponent({
                            text: Resources.t("words.auditContentDefinition"),
                            size: "sizeMid",
                            shadow: "colorPurple"
                        }))}
                    </div>
                </div>
                <div class="${s.white}">
                    <div class="${s.content}">
                        <div class="${s.container}">
                            ${this.draw(new WebsiteBlackFlowGridComponent({
                                title: Resources.t("words.auditContentStrengthWeakness"),
                                lines: [{
                                    entries: [
                                        {
                                            title: Resources.t("words.auditAnalyze"),
                                            description: Resources.t("words.auditAnalyzeDescription"),
                                            illustration: "topicsScore"
                                        },
                                        {
                                            title: Resources.t("words.auditBestOpportunities"),
                                            description: Resources.t("words.auditOpportunitiesDescription"),
                                            illustration: "topicsFire"
                                        },
                                        {
                                            title: Resources.t("words.auditOptimize"),
                                            description: Resources.t("words.auditOptimizeDescription"),
                                            illustration: "optimize"
                                        }
                                    ]
                                }]
                            }))}
                        </div>
                        <div class="${s.container}">
                            ${this.draw(new WebsiteBlackFlowComponent({
                                bigTitle: Resources.t("words.auditUpdateOptimizeSeo"),
                                image: NetworkVendor.image("blog-af.webp"),
                                texts: {
                                    canCollapse: true,
                                    entries: [
                                        {
                                            title: Resources.t("words.auditProductSheet"),
                                            description: Resources.t("words.auditProductSheetDescription"),
                                            icon: "pageProduct",
                                            iconColor: "colorBlack"
                                        },
                                        {
                                            title: Resources.t("words.auditBlogArticle"),
                                            description: Resources.t("words.auditBlogArticleDescription"),
                                            icon: "pageBlog",
                                            iconColor: "colorBlack"
                                        },
                                        {
                                            title: Resources.t("words.auditProductCategories"),
                                            description: Resources.t("words.auditProductCategoriesDescription"),
                                            icon: "pageShop",
                                            iconColor: "colorBlack"
                                        },
                                        {
                                            title: Resources.t("words.auditPresentationPage"),
                                            description: Resources.t("words.auditPresentationPageDescription"),
                                            icon: "pageSimple",
                                            iconColor: "colorBlack"
                                        }
                                    ]
                                }
                            }))}
                        </div>
                        <div class="${s.container}">
                            ${this.draw(new ComponentWebsiteBlackAllieSimple())}
                        </div>
                    </div>
                </div>
                <div class="${s.content}">
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackFlowStepsComponent({
                            union: {
                                description: Resources.t("words.auditCompetitiveAnalysisIntro"),
                                steps: [
                                    {
                                        step: "1",
                                        title: Resources.t("words.auditKeywordAndCompetitors"),
                                        description: Resources.t("words.auditKeywordAndCompetitorsDescription")
                                    },
                                    {
                                        step: "2",
                                        title: Resources.t("words.auditCommonPoints"),
                                        description: Resources.t("words.auditCommonPointsDescription"),
                                        image: NetworkVendor.image("blog-ah.webp"),
                                        imageAlt: Resources.t("words.auditCommonPoints")
                                    },
                                    {
                                        step: "3",
                                        title: Resources.t("words.auditSuggestions"),
                                        description: Resources.t("words.auditSuggestionsDescription"),
                                        image: NetworkVendor.image("blog-r.webp"),
                                        imageAlt: Resources.t("words.editorSeoContentScore")
                                    }
                                ]
                            }
                        }))}
                    </div>
                </div>
            </div>
        `;
    }
}
